import React from 'react'
import { Downgraded } from '@hookstate/core'
import { useLang } from '~/hooks/useLang'
import { Grid, Typography } from '@mui/material'
import ColumnChartHorizontal from '~/components/ColumnChartMui/HorizontalChart'
import useManagementQualifiersDrugsState from '~/features/Management/stores/ManagementQualifiersDrugsState'
import { calculateBarChartTotal } from '~/utils/format'

interface ChartsDrugsProps {
  readonly expandFilterSearch: boolean
}

export default function ChartsDrugs({ expandFilterSearch }: ChartsDrugsProps) {
  const { translate } = useLang()
  const { occurrencesAssociatedDrugs } = useManagementQualifiersDrugsState()

  return (
    <Grid
      container
      xs={12}
      sx={{
        display: 'flex',
        paddingX: 3,
        paddingTop: 3,
        justifyContent: 'space-between',
      }}
    >
      <Grid item xs={12} hidden={!expandFilterSearch} paddingBottom={1}>
        <Typography sx={{ fontWeight: 'bold', fontSize: 16 }}>
          {translate('Registered drugs')}
        </Typography>
      </Grid>

      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedDrugs()
            .occurrencesAssociatedDrugByType.attach(Downgraded)
            .get()}
          title={'DrugType:name'}
          subtitle={`Total de drogas: ${calculateBarChartTotal(
            occurrencesAssociatedDrugs()
              .occurrencesAssociatedDrugByType.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'typeMinus'}
          colorBar="primary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedDrugs()
            .occurrencesAssociatedDrugByOccurrenceType.attach(Downgraded)
            .get()}
          title={`${translate('DrugModel:name')}`}
          subtitle={`Total de drogas: ${calculateBarChartTotal(
            occurrencesAssociatedDrugs()
              .occurrencesAssociatedDrugByOccurrenceType.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'typeMinus'}
          colorBar="tertiary"
        />
      </Grid>

      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedDrugs()
            .occurrencesAssociatedDrugByCircumstance.attach(Downgraded)
            .get()}
          title={`${translate('Circunstance of the drug')}`}
          subtitle={`Total de drogas: ${calculateBarChartTotal(
            occurrencesAssociatedDrugs()
              .occurrencesAssociatedDrugByCircumstance.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'situations'}
          colorBar="tertiary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedDrugs()
            .occurrencesAssociatedDrugByDestination.attach(Downgraded)
            .get()}
          title={`${translate('Final destination of the drug')}`}
          subtitle={`Total de drogas: ${calculateBarChartTotal(
            occurrencesAssociatedDrugs()
              .occurrencesAssociatedDrugByDestination.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'finals destinations'}
          colorBar="secondary"
        />
      </Grid>
    </Grid>
  )
}
